<template>
  <v-menu
    location="bottom"
    class="text-left">
    <template v-slot:activator="{ props }">
      <v-btn
        type="text"
        v-bind="props"
        class="text-h6 text-uppercase text-white px-sm-6"
      >
        Сервисы
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
    </template>
    <v-list class="top_menu__button__list">
      <v-list-item
        class="top_menu__button__list-item"
        v-for="item in items"
        :key='item.title'
        @click="$emit('item-click', item)"
      >
        <v-list-item-title class="top_menu__button__list-title text-body-1">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ServiceMenu",
  props: {
    items: {
      type: Array,
      default: () => [],
    }
  },
  emits: ['item-click']
}
</script>

<style lang="scss" scoped>

</style>
